import { DacConfig } from '../../shared/services/dac-config.service';
import { NavBarService } from '../../theme/services/nav-bar.service';
import { UniqueIdService } from '../../shared/services/unique-id.service';
import { FlaggedQuestionsListComponent } from '../report-items/flagged-questions-list/flagged-questions-list.component';
import { HtmlContentItemComponent } from "../report-items/html-content-item/html-content-item.component";
import { ScaleResultsSectionsListComponent } from "../report-items/scale-results-sections-list/scale-results-sections-list.component";
import { TextItemComponent } from "../text-item/text-item.component";
import { ComputedScaleComponent } from "../report-items/computed-scale/computed-scale.component";
import { AssessmentResult } from "../../shared/models/assessment-result";
import { AssessmentService } from "../../shared/services/assessment.service";
import { ClientService } from "../../shared/services/client.service";
import { AddoScaleResultsComponent } from "../report-items/addo-scale-results/addo-scale-results.component";
import { Assessment } from "../../shared/models/assessment";
import { ScaleResult } from "../../shared/models/scale-result";
import { AssessmentHydrator } from "../../shared/services/assessment-hydrator.service";
import { ReportService } from "../services/report.service";
import { OnInit, ComponentFactoryResolver, ComponentRef, OnDestroy, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScaleResultsSummaryComponent } from "app/reports/report-items/scale-results-summary/scale-results-summary.component";
import { TherapistScaleResultsComponent } from "app/reports/report-items/therapist-scale-results/therapist-scale-results.component";
import { PclAssessmentResultsComponent } from 'app/reports/report-items/pcl-assessment-results/pcl-assessment-results.component';
import { AssessmentQuestionsListComponent } from 'app/reports/report-items/assessment-questions-list/assessment-questions-list.component';
import 'rxjs/add/observable/fromPromise';
import { QuestionActionListComponent } from '../report-items/question-action-list/question-action-list.component';
import { ClientScaleResultsComponent } from '../report-items/client-scale-results/client-scale-results.component';
import { SsoCrossDomainMessenger } from 'app/shared/services/sso-cross-domain-messenger';
import { FlaggedQuestionsListSimpleComponent } from '../report-items/flagged-questions-list-simple/flagged-questions-list-simple.component';
var ReportViewerComponent = /** @class */ (function () {
    function ReportViewerComponent(resolver, assessmentService, clientService, hydrator, route, reportService, uniqueIdService, navBarService, dacConfig, crossDomainMessenger, elementRef) {
        this.resolver = resolver;
        this.assessmentService = assessmentService;
        this.clientService = clientService;
        this.hydrator = hydrator;
        this.route = route;
        this.reportService = reportService;
        this.uniqueIdService = uniqueIdService;
        this.navBarService = navBarService;
        this.dacConfig = dacConfig;
        this.crossDomainMessenger = crossDomainMessenger;
        this.elementRef = elementRef;
        this._reportItemClassNames = ["report-item-component"];
        this.menuItems = [];
        this.componentItems = [];
        this.componentItemsById = new Map();
        this.hasLoadedResults = false;
        this.displayTherapistNotes = false;
        this.reportId = "";
    }
    ReportViewerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.queryParamsSubscription = this.route.queryParams.subscribe(function (params) {
            if (params['notes'] && params['notes'] == '1') {
                _this.displayTherapistNotes = true;
            }
            else {
                _this.displayTherapistNotes = false;
            }
        });
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            var clientId = params['id'];
            if (!clientId || typeof clientId !== "string") {
                // this.router.navigate(['../']);
                return;
            }
            _this.navBarService.setupReportSidebar(clientId);
            var reportId = params['reportId'];
            if (!reportId || typeof reportId !== "string") {
                return;
            }
            var assignmentId = +params['assignmentId'];
            if (!assignmentId || isNaN(assignmentId)) {
                return;
            }
            _this.loadReport(clientId, reportId, assignmentId);
            _this.navBarSubscription = _this.navBarService.navBarAction.subscribe(function (item) {
                _this.goToNavItem(item);
            });
        });
    };
    ReportViewerComponent.prototype.showCommandButtons = function () {
        return !this.dacConfig.seamlessMode;
    };
    ReportViewerComponent.prototype.getClasses = function () {
        var obj = { 'display-therapist-notes': this.displayTherapistNotes };
        obj[this.reportId] = true;
        return obj;
    };
    ReportViewerComponent.prototype.ngOnDestroy = function () {
        if (this.queryParamsSubscription) {
            this.queryParamsSubscription.unsubscribe();
        }
        if (this.navBarSubscription) {
            this.navBarSubscription.unsubscribe();
        }
        if (this.routeParamsSubscription) {
            this.routeParamsSubscription.unsubscribe();
        }
        this.navBarService.clearReportSidebar();
    };
    ReportViewerComponent.prototype.loadReport = function (clientId, reportId, assignmentId) {
        var _this = this;
        // get the client, get the reportData
        Promise.all([this.clientService.getClient(clientId), this.reportService.get(reportId)])
            .then(function (results) {
            var client = results[0];
            var report = results[1];
            _this.reportId = reportId;
            if (!client || !client.assignments || !client.assignments.length) {
                throw new Error("No assessments to generate a report");
            }
            var assignment = client.getAssignment(assignmentId);
            if (!assignment) {
                throw new Error("Assignment could not be found with this id");
            }
            else {
                _this.assignment = assignment;
            }
            if (!report) {
                throw new Error("No report data to display");
            }
            _this._reportData = report;
            // TODO: stephen this is a bug as it loads ALL of the client's assessments they've taken.
            var completedResultIds = assignment.getResultIds();
            var resultPromises = completedResultIds.map(function (r) { return _this.assessmentService.getAssessmentResult(clientId, r); });
            return Promise.all(resultPromises);
        })
            .then(function (results) {
            // let processedResults = results;
            var reportVariables = _this._reportData.variables || [];
            var reportComputedVariables = _this._reportData.computedResults || [];
            var processedResults = _this.processReportComputations(reportComputedVariables, results);
            var variables = _this.resolveVariables(reportVariables, processedResults, clientId);
            console.log("variables: ", variables);
            _this._reportData.items.forEach(function (i) {
                if (i.display === false) {
                    return;
                }
                var component = _this.createComponent(i.type, i.data, processedResults, variables);
                var componentId = _this.uniqueIdService.generate();
                _this.componentItems.push(component);
                _this.componentItemsById.set(componentId, component);
                _this.addComponentToNavBar(i, componentId);
            });
            // console.log("Component item counts are: ", this.componentItems.length);
            Promise.all(_this.componentItems.map(function (ci) {
                return ci.instance.itemLoaded().toPromise();
            })).then(function (items) {
                // fire off event on the dom
                // we need to let outside listeners like the server pdf generator know we have finished loading so we can generate the report
                console.log("adding dac-report-loaded class");
                document.body.classList.add("dac-report-loaded");
                // this.elementRef.nativeElement.dispatchEvent(new Event("dac-report-loaded", {bubbles:true}));
                _this.hasLoadedResults = true;
                _this.handleLoadedResize();
            })
                .catch(function (error) {
                console.error(error);
                // console.log("dispatching dac-report-load-failed event");
                // this.elementRef.nativeElement.dispatchEvent(new Event("dac-report-load-failed", {bubbles:true}));
                _this.hasLoadedResults = true;
            });
        });
    };
    Object.defineProperty(ReportViewerComponent.prototype, "ReportName", {
        get: function () {
            if (this._reportData) {
                return this._reportData.name;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    ReportViewerComponent.prototype.goBack = function () {
        // TODO: stephen we are dependent on a global here.. should inject angular dependency.
        window.history.back();
    };
    ReportViewerComponent.prototype.handleLoadedResize = function () {
        var element = this.elementRef.nativeElement;
        var height = element.ownerDocument.body.scrollHeight;
        var width = element.ownerDocument.body.scrollWidth;
        this.crossDomainMessenger.sendMessage('dac.report-loaded', { height: height, width: width, reportId: this.reportId });
    };
    ReportViewerComponent.prototype.processReportComputations = function (computed_results, results) {
        var _this = this;
        if (!computed_results || !computed_results.length) {
            return results;
        }
        var newResults;
        newResults = computed_results.map(function (cs) {
            var result = new AssessmentResult();
            // make the result and the assessment the same... then we can just refer to the assessment by the uid
            // and all our code works the same...
            result.id = cs.id;
            result.assessment = new Assessment();
            result.assessment.uid = cs.id;
            result.assessment.description = cs.description;
            result.assessment.name = cs.name;
            result.scaleResults.push(_this.createScaleResultFromComputation(cs, results));
            return result;
        });
        return results.concat(newResults);
    };
    ReportViewerComponent.prototype.createScaleResultFromComputation = function (computation, results) {
        var _this = this;
        var scaleResult = new ScaleResult();
        if (computation.scale) {
            scaleResult.scale = this.hydrator.hydrateScale(computation.scale);
        }
        // calculation, assessments
        if (computation.items) {
            computation.items.forEach(function (i) { return _this.processCalculation(scaleResult, i, computation.calculation, results); });
            console.log("score is ", scaleResult.score);
            scaleResult.range = scaleResult.scale.getRangeForScore(scaleResult.score);
            console.log("new range is ", scaleResult.range);
        }
        return scaleResult;
    };
    ReportViewerComponent.prototype.resolveVariables = function (variables, results, clientId) {
        var _this = this;
        var resolved = [];
        resolved = variables.map(function (v) {
            if (!v.type || !v.value) {
                return null;
            }
            var value = null;
            if (v.type == 'computed_scale_result') {
                return _this.resolveComputedScale(v, results);
            }
            else if (v.type == 'scale_result') {
                return _this.resolveResultScale(v, results);
            }
            else if (v.type == 'scale') {
                return _this.resolveScale(v, results);
            }
        }).filter(function (v) { return v != null; });
        resolved.push({ id: "ClientToken", value: clientId });
        resolved.push({ id: "reportTitle", value: this.ReportName });
        resolved.push({ id: "logoURL", value: this.dacConfig.applicationLogoUrl });
        resolved.push({ id: "reportHeaderImgURL", value: this.dacConfig.reportHeaderImgURL });
        return resolved;
    };
    ReportViewerComponent.prototype.resolveResultScale = function (variableData, results) {
        var result = results.find(function (r) { return r.assessment.uid == variableData.assessmentUid; });
        return this.resolveVariableFromResult(variableData, result);
    };
    ReportViewerComponent.prototype.resolveScale = function (variableData, results) {
        var result = results.find(function (r) { return r.assessment.uid == variableData.assessmentUid; });
        if (result) {
            var scaleResult = result.scaleResults.find(function (sr) { return sr.scale.id == variableData.scale; });
            var value = scaleResult.scale[variableData.value];
            if (value) {
                return { id: variableData.id, value: value };
            }
        }
        return null;
    };
    ReportViewerComponent.prototype.resolveVariableFromResult = function (variableData, result) {
        if (result) {
            var scaleResult = result.scaleResults.find(function (sr) { return sr.scale.id == variableData.scale; });
            var value = void 0;
            if (variableData.value == 'score') {
                value = scaleResult.score;
            }
            else if (variableData.value == 'scorePercentage') {
                value = scaleResult.scorePercentage;
            }
            else {
                value = scaleResult.range[variableData.value];
            }
            if (value) {
                return { id: variableData.id, value: value };
            }
        }
        return null;
    };
    ReportViewerComponent.prototype.resolveComputedScale = function (variableData, results) {
        var result = results.find(function (r) { return r.id == variableData.computedResultId; });
        return this.resolveVariableFromResult(variableData, result);
    };
    ReportViewerComponent.prototype.processCalculation = function (scaleResult, item, calculation, results) {
        var result = results.find(function (r) { return r.assessment.uid == item.assessmentUid; });
        var processScaleResult = result ? result.scaleResults.find(function (sr) { return sr.scale.id == item.scaleId; }) : null;
        if (!(result && processScaleResult)) {
            return;
        }
        if (calculation === "SUM") {
            scaleResult.score += processScaleResult.score;
        }
    };
    ReportViewerComponent.prototype.createComponent = function (type, data, results, variables) {
        var component = this.getComponentFromType(type);
        var factory = this.resolver.resolveComponentFactory(component);
        var componentRef = this.container.createComponent(factory);
        var reportItemComponent = componentRef.instance;
        reportItemComponent.setReportData(data, results, variables);
        // add the specific classes for report items here
        if (componentRef.location && componentRef.location.nativeElement) {
            var reportItemClassNames = reportItemComponent.getHTMLClassNames() || [];
            var classNameString = this._reportItemClassNames.concat(reportItemClassNames).join(" ");
            var el = componentRef.location.nativeElement;
            el.className = classNameString;
        }
        return componentRef;
    };
    ReportViewerComponent.prototype.getNavIconClasses = function (itemId) {
    };
    ReportViewerComponent.prototype.goToNavItem = function (item) {
        // TODO: stephen use the navigator service instead of this one.
        if (!this.componentItemsById.has(item.id)) {
            console.error("tried to navigate to missing component with item id " + item.id);
            return;
        }
        var component = this.componentItemsById.get(item.id);
        var element = component.location.nativeElement;
        if (element) {
            // TODO: stephen change out this hack to accomodate the fixed navbar at the top.
            var navBar = document.querySelector("dac-navbar nav");
            var navBarHeight = navBar.clientHeight;
            // adapted from https://stackoverflow.com/a/13857312
            element.scrollIntoView(true);
            var scrolledY = window.scrollY;
            if (scrolledY) {
                window.scroll(0, scrolledY - navBarHeight);
            }
        }
    };
    ReportViewerComponent.prototype.addComponentToNavBar = function (data, componentId) {
        if (data.title && componentId) {
            this.navBarService.addReportNavBarItem(componentId, data.title);
            // let hasIcon = false;
            // let iconClasses = data.titleIconClasses;
            // if (iconClasses) {
            //   hasIcon = true;
            // }
            // this.menuItems.push({id: componentId, name: data.title, hasIcon:hasIcon, iconClasses:iconClasses});
        }
    };
    ReportViewerComponent.prototype.getComponentFromType = function (type) {
        var component = null;
        switch (type) {
            case 'HTMLContentItem':
                {
                    component = HtmlContentItemComponent;
                }
                break;
            case 'ScaleResultsSectionsList':
                {
                    component = ScaleResultsSectionsListComponent;
                }
                break;
            case 'AddoScaleResults':
                {
                    component = AddoScaleResultsComponent;
                }
                break;
            case 'ComputedScale':
                {
                    component = ComputedScaleComponent;
                }
                break;
            case 'ScaleResultsSummary':
                {
                    component = ScaleResultsSummaryComponent;
                }
                break;
            case 'TherapistScaleResults':
                {
                    component = TherapistScaleResultsComponent;
                }
                break;
            case 'FlaggedQuestionsList':
                {
                    component = FlaggedQuestionsListComponent;
                }
                break;
            case 'FlaggedQuestionsListSimple':
                {
                    component = FlaggedQuestionsListSimpleComponent;
                }
                break;
            case 'PclAssessmentResults':
                {
                    component = PclAssessmentResultsComponent;
                }
                break;
            case 'AssessmentQuestionsList':
                {
                    component = AssessmentQuestionsListComponent;
                }
                break;
            case 'QuestionActionList':
                {
                    component = QuestionActionListComponent;
                }
                break;
            case 'ClientScaleResults':
                {
                    component = ClientScaleResultsComponent;
                }
                break;
            default:
                {
                    component = TextItemComponent;
                }
                break;
        }
        return component;
    };
    ReportViewerComponent.prototype.print = function () {
        this.showPrintDialog = true;
    };
    ReportViewerComponent.prototype.closePrintDialog = function () {
        // reset it once we've closed the dialog.
        this.showPrintDialog = false;
        // this.displayTherapistNotes = false;
    };
    return ReportViewerComponent;
}());
export { ReportViewerComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-viewer/report-viewer.component.ts.pre-build-optimizer.js